import "./Project.css";
import "../MachineLearningCommon.css";
import Button from "../button/Button";
import { Link, useNavigate } from "react-router-dom";

const Project = () => {
  return (
    <div id="service-machine" className="machinemainclass">
      <div className="sContainer">
        <div className="serviceContent">
          <h2>Let’s Build Something Smarter Together</h2>
          <p>
           Whether you’re fixing bottlenecks or building something from scratch, our machine learning development company delivers expert AI development services designed to create long-term, measurable impact.
          </p>
          <div>
            <Link to="/contact_us" className="link">
              <Button arrowColor="purple" text="Get a Free Consultation Now" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Project;
